<template>
  <div class="evidence-attachment">
    <div class="text-center py-4">
      <div class="fw-bold mb-3">Screenshot Evidence</div>
      <PrivateEvidenceImage
        ref="image"
        :city-id="cityId"
        :listing-id="listingId"
        :evidence="evidence"
        image-class="evidence-image"
        @loaded="$emit('loaded')"
        @error="$emit('error')"
      />
      <div v-if="sourceUrl" class="mt-2 small text-muted">
        Source: {{ sourceUrl }}
      </div>
      <div v-if="formattedDate" class="small text-muted">
        Captured {{ formattedDate }}
      </div>
    </div>
  </div>
</template>

<script>
import PrivateEvidenceImage from './PrivateEvidenceImage.vue';

export default {
  components: {
    PrivateEvidenceImage
  },
  props: {
    cityId: String,
    listingId: String,
    evidence: Object,
    sourceUrl: String,
    capturedAt: [String, Date, Object]
  },
  emits: ['loaded', 'error'],
  methods: {
    /** Printing requires the authenticated screenshot to be fully loaded. */
    async waitUntilReady() {
      await this.$refs.image.waitUntilReady();
    }
  },
  computed: {
    formattedDate() {
      if (!this.capturedAt) return null;
      const date = typeof this.capturedAt?.toDate === 'function'
        ? this.capturedAt.toDate()
        : new Date(this.capturedAt);
      return isNaN(date) ? null : date.toLocaleDateString(undefined, {
        year: 'numeric', month: 'long', day: 'numeric',
        hour: 'numeric', minute: '2-digit'
      });
    }
  }
}
</script>

<style scoped>
.evidence-attachment {
  page-break-before: always;
}
:deep(.evidence-image) {
  max-width: 100%;
  max-height: 8in;
  object-fit: contain;
  border: 1px solid #dee2e6;
}
</style>
